import swal from "sweetalert";

export const alert = (title, data, type) => {
  return swal(title, data, type);
};

export const warning = (title = "Are You Sure!", text = "Are you sure you want to proceed?") => {
  return swal({
    title: title,
    text: text,
    icon: "warning",
    dangerMode: true,
    buttons: {
      cancel: {
        text: "Cancel",
        value: null,
        visible: true,
        className: "swal-button--cancel",
        closeModal: true,
      },
      confirm: {
        text: title.toLowerCase().includes("sign out") || title.toLowerCase().includes("logout") ? "Sign out" : "Confirm",
        value: true,
        visible: true,
        className: "swal-button--danger",
        closeModal: true,
      },
    },
  });
};

//Delete Warning for category
export const warningForText = (text) => {
  return swal({
    title: "Are You Sure!",
    text: text,
    icon: "warning",
    dangerMode: true,
    buttons: true,
  });
};

